import { render, staticRenderFns } from "./ERegistrationPublicRegisterForm.vue?vue&type=template&id=555e08c2&scoped=true&"
import script from "./ERegistrationPublicRegisterForm.vue?vue&type=script&lang=js&"
export * from "./ERegistrationPublicRegisterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555e08c2",
  null
  
)

/* custom blocks */
import block0 from "@/locales/actions.locale?vue&type=custom&index=0&blockType=i18n&issuerPath=E%3A%5Capp%5CJenkins%5Cworkspace%5CAll_IaaS_Farm%5C0%20nextoreV3bdclient_build%5Csrc%5Csrc%5Cpublic%5Cmodules%5Ce-registration%5Ccomponents%5Ce-registration-public-register%5CERegistrationPublicRegisterForm.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "./ERegistrationPublicRegisterForm.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(component)

export default component.exports